// this file is generated by update_shopify_store_data.py at 2026-11-03 20:15:49.323108
var courses = [
    {
        "course_id": "0EE7F89C-B2CF-F011-99A4-005056A7327D",
        "course_version": 2,
        "name": "Springer Publishing - MEDSURG-BC\u2122 Certification Online Review",
        "course_type": 1,
        "author_information": "Springer Publishing",
        "description": "Prepare for the Medical-Surgical Nursing (MEDSURG-BC\u2122) certification exam with a comprehensive online review aligned to the latest exam outline. This course features learning modules with audio narration, knowledge check questions, and a full-length practice test to strengthen test-taking skills and boost exam-day confidence. \r\n\r\nMEDSURG-BC\u2122 is a registered trademark of the American Nurses Credentialing Center (ANCC). The ANCC does not endorse this resource, nor does it have a proprietary relationship with Springer Publishing Company.",
        "learning_objectives_html": "Upon completion of this online activity, the participant should be able to:\r\n<ul>\r\n    <li>Describe key concepts and clinical knowledge areas related to adult medical-surgical nursing practice</li>\r\n    <li>Apply critical-thinking and clinical judgment skills to analyze patient-care scenarios across diverse health conditions</li>\r\n    <li>Demonstrate readiness for the MEDSURG-BC&trade; certification exam through self-assessment activities</li>\r\n</ul>\r\n\"",
        "course_outline_html": "<ul>\r\n    <li>Introduction</li>\r\n    <li>Module 1: Certification Exam</li>\r\n    <li>Module 2: Legal, Ethical, and Professional Issues</li>\r\n    <li>Module 3: Homeostasis/Bedside Emergencies</li>\r\n    <li>Module 4: Cardiovascular System</li>\r\n    <li>Module 5: Pulmonary System</li>\r\n    <li>Module 6: Neurologic System</li>\r\n    <li>Module 7: Musculoskeletal System</li>\r\n    <li>Module 8: Gastrointestinal System</li>\r\n    <li>Module 9: Urologic and Renal Systems</li>\r\n    <li>Module 10: Endocrine System</li>\r\n    <li>Module 11: Integumentary System</li>\r\n    <li>Module 12: Hematologic System</li>\r\n    <li>Module 13: Immune System</li>\r\n</ul>",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "13259F71-EC33-E611-9D73-005056B17F80",
                "course_category_name": "Medical Surgical",
                "is_system_course_category": null
            },
            {
                "course_category_id": "66608656-21BB-F011-99A1-005056A7C0C7",
                "course_category_name": "Springer Publishing",
                "is_system_course_category": null
            },
            {
                "course_category_id": "30C21A06-4DBA-F011-99A1-005056A7C0C7",
                "course_category_name": "Springer Publishing",
                "is_system_course_category": null
            },
            {
                "course_category_id": "7C33B687-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Procedures",
                "is_system_course_category": null
            },
            {
                "course_category_id": "3DA45D8A-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Professional Development",
                "is_system_course_category": null
            },
            {
                "course_category_id": "3C4352CA-6E88-11DB-BFA9-000423AF2167",
                "course_category_name": "Disorders and Conditions",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EB0C13C7-0116-EA11-8041-005056B15B8C",
                "course_category_name": "All Settings",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2A010654-ECD9-F011-99A4-005056A7F5E9",
                "course_category_name": "Springer Publishing - Single Courses for Purchase (NGL)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "27BB2B08-35D4-E511-93E1-005056B12CFE",
                "course_category_name": "Patient Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": null,
            "accreditation_statement": null,
            "course_level_accreditation_statement": null,
            "credit_display_name": null,
            "credit_units": null,
            "credit_unit_display_name": null
        },
        "sub_courses": []
    }
];